import { CommonMoreArrowIcon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'

import styles from './FlickingContentMoreButton.module.scss'

interface Props {
  name?: string
  hideButtonName?: boolean
  onClick?: () => void
  clickCode?: string
}

export default function FlickingContentMoreButton(props: Props) {
  const { name: _name, hideButtonName, onClick, clickCode } = props

  const name = _name || '더보기'

  return (
    <Clickable className={styles.btn} onClick={onClick} nClickCode={clickCode}>
      <CommonMoreArrowIcon className={styles.icon} aria-hidden="true" />
      {hideButtonName ? <span className="place_blind">{name}</span> : name}
    </Clickable>
  )
}
